import { NavLink, useLocation } from 'react-router-dom';
import { Home, Calendar, BookOpen, ShoppingCart, MoreHorizontal } from 'lucide-react';
import { type ReactNode } from 'react';

const tabs: { to: string; label: string; icon: ReactNode }[] = [
  { to: '/', label: 'Home', icon: <Home size={22} strokeWidth={1.8} /> },
  { to: '/plan', label: 'Plan', icon: <Calendar size={22} strokeWidth={1.8} /> },
  { to: '/recipes', label: 'Rezepte', icon: <BookOpen size={22} strokeWidth={1.8} /> },
  { to: '/shopping', label: 'Einkauf', icon: <ShoppingCart size={22} strokeWidth={1.8} /> },
  { to: '/more', label: 'Mehr', icon: <MoreHorizontal size={22} strokeWidth={1.8} /> },
];

export default function BottomNav() {
  const location = useLocation();
  const isMoreActive = location.pathname.startsWith('/more') || location.pathname.startsWith('/settings') || location.pathname.startsWith('/tracking');

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-warm-50/90 backdrop-blur-lg border-t border-warm-200 safe-bottom md:hidden">
      <div className="flex items-center justify-around h-[72px]">
        {tabs.map((tab) => {
          const forceActive = tab.to === '/more' && isMoreActive;
          return (
            <NavLink
              key={tab.to}
              to={tab.to}
              end={tab.to === '/'}
              className={({ isActive }) =>
                `relative flex flex-col items-center justify-center min-w-[52px] min-h-[52px] px-3 py-1.5 text-xs font-medium transition-colors ${
                  isActive || forceActive ? 'text-teal-400' : 'text-warm-400'
                }`
              }
            >
              {({ isActive }) => (
                <>
                  {(isActive || forceActive) && (
                    <span className="absolute top-0 left-1/2 -translate-x-1/2 w-8 h-0.5 bg-teal-400 rounded-full" />
                  )}
                  <span className="mb-1">{tab.icon}</span>
                  <span>{tab.label}</span>
                </>
              )}
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
